export enum RoleNameEnum {
        HumanResourcesOutsourcingOpenParenthesisHROCloseParenthesis = 30,
        HumanResourcesConsultantOpenParenthesisHRCCloseParenthesis = 31,
        GuestHumanResourcesConsultantOpenParenthesisHRCCloseParenthesis = 41,
}